export default {
  width: -1,
  height: -1,
  top: -1,
  left: -1,
};